import { FC, useState } from 'react';
import { merge } from '../../helpers/Utility';
import { ClockInStatus, useClockService } from '../../services/clockIn/ClockService';
import { Button } from '../shared/button/Button';
import { Watch } from '../shared/icons/Watch';
import { Modal } from '../shared/modal/Modal';
import strings from './clock.translations';
import { ClockHandler } from './ClockHandler';

interface ClockPopoverProps {}

export const ClockPopover: FC<ClockPopoverProps> = () => {
  const [open, setOpen] = useState<boolean>(false);
  const clockState = useClockService(service => service.clockState);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <ClockHandler
          isModal={true}
          closeHandler={() => {
            setOpen(false);
          }}
        />
      </Modal>
      <div className={merge('relative sm:inline-block flex-col w-full')}>
        <Button
          primary
          onClick={() => {
            setOpen(!open);
          }}
          className="flex items-center justify-center w-full gap-2"
        >
          <Watch className="w-4 h-6" />
          {clockState === ClockInStatus.In ? strings.common.clockOut : strings.common.clockIn}
        </Button>
      </div>
    </>
  );
};
